enum StatusesUrl {
  NOSTRO = 'transactions-nostro',
  OUTGOING = 'transactions-outgoing',
  INCOMING = 'transactions-incoming',
  INTERNAL = 'transactions-internal',
  EXCHANGE = 'transactions-exchange',
}

export default StatusesUrl;
